module.exports = __webpack_public_path__ + "img/Monte_Kope_44.9f929368.jpg";